import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { BaseUrl } from "../../helper/BaseUrl";
import { toast } from "react-toastify";
import PhoneInput from "react-phone-input-2";
export default function ContactForm() {

    const navigate = useNavigate();
    const [loading, setLoading] = useState(false);
    // const [captchaToken, setCaptchaToken] = useState(null);
    const currentUrl = typeof window !== "undefined" ? window.location.href : "";
    const sourceUrl = typeof window !== "undefined" ? sessionStorage.getItem("source_url") || "" : "";
    const [formData, setFormData] = useState({
        form_type: "contact_form",
        name: "",
        email: "",
        phone: "+91-",
        looking_for: "",
        source_url: sourceUrl,
        current_url: currentUrl,
    })

    const [country, setCountry] = useState("in");
    const [phoneTouched, setPhoneTouched] = useState(false);
    const minPhoneDigits = country === "in" ? 10 : 9;
    const maxPhoneDigits = country === "in" ? 10 : 13;
    const getPhoneValidationMessage = (phoneNumber) => {
      if (/^\d+$/.test(phoneNumber) && phoneNumber.length >= minPhoneDigits && phoneNumber.length <= maxPhoneDigits) return "";
      if (country === "in") return "Please enter exactly 10 digits for your phone number.";
      if (phoneNumber.length < minPhoneDigits) return "Please enter at least 9 digits for your phone number.";
      if (phoneNumber.length > maxPhoneDigits) return "Please enter no more than 13 digits for your phone number.";
      return "Please enter digits only for your phone number.";
    };
    const phoneError = phoneTouched ? getPhoneValidationMessage(formData.phone.split("-")[1]?.trim() || "") : "";
    const handleChange = (e) => {
        const { name, value } = e.target;

        if (name === "phone") {
            const numericValue = e.target.value.replace(/\D/g, "").slice(0, maxPhoneDigits);
            setFormData(prev => ({
                ...prev,
                [name]: numericValue
            }));
        }
        else if (name === "name") {
            const textValue = value.replace(/[0-9]/g, "");
            setFormData(prev => ({
                ...prev,
                [name]: textValue
            }));
        }
        else {
            setFormData(prev => ({
                ...prev,
                [name]: value
            }));
        }
    };
    useEffect(() => {
        fetch("https://ipapi.co/json/")
            .then((res) => res.json())
            .then((data) => {
                if (data && data.country_code) {
                    const code = data.country_code.toLowerCase();
                    setCountry(code);

                    const dialCodes = {
                        us: "+1",
                        in: "+91",
                        gb: "+44",
                        ca: "+1",
                        au: "+61",
                        ae: "+971",
                    };

                    const dialCode = dialCodes[code] || "+91";
                    setFormData((prev) => ({
                        ...prev,
                        phone: `${dialCode} - `,
                    }));
                }
            })
            .catch((err) => console.log("Location fetch error:", err));
    }, []);



    // const handleCaptcha = (value) => {
    //     setCaptchaToken(value);
    // };


    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!formData.name.trim()) {
            toast.error("Name is required");
            return;
        }
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (!emailRegex.test(formData.email)) {
            toast.error("Please enter a valid email (example@gmail.com)");
            return;
        }

        const phoneNumber = formData.phone.split("-")[1]?.trim() || "";
        if (!/^\d+$/.test(phoneNumber) || phoneNumber.length < minPhoneDigits || phoneNumber.length > maxPhoneDigits) {
            setPhoneTouched(true);
            return;
        }

        if (!formData.looking_for) {
            toast.error("Please choose a Service");
            return;
        }

        // if (!captchaToken) {
        //     toast.error("Please complete the CAPTCHA");
        //     return;
        // }

        try {
            setLoading(true);
            const response = await fetch(`${BaseUrl}/api/contact/store`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify(formData),
            });

            const result = await response.json();

            if (result.error === false) {
          setPhoneTouched(false);
                setFormData({
                    form_type: "contact_form",
                    name: "",
                    email: "",
                    phone: "",
                    looking_for: "",
                    source_url: sessionStorage.getItem("source_url") || "",
                    current_url: window.location.href,
                });

                setTimeout(() => {
                    navigate("/thank-you");
                }, 300);

            } else {
                toast.error(result.message)
            }
        } catch (error) {
            console.error("Error:", error);
            toast.error("Something went wrong while submitting the form.");
        } finally {
            setLoading(false);
        }
    }




    return (
        <>
            <section className="contactform-area">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-12">
                            <div className="conatctform-box">
                                <div className="row ">
                                    <div className="col-lg-6">
                                        <div className="contactform-image">
                                            <img src="/assets/images/contactform-img.webp" className="img-responsive" alt="contact-form" />
                                        </div>
                                    </div>
                                    <div className="col-lg-6 col-md-12">
                                        <form onSubmit={handleSubmit} >
                                            <div className="contact-form">
                                                <div className="row text-center">
                                                    <div className="col-lg-12 col-md-12 col-12">
                                                        <div className="form-group">
                                                            <input type="text" placeholder="Name*" name="name" value={formData.name} onChange={handleChange} required className="form-control" />
                                                        </div>
                                                    </div>
                                                    <div className="col-lg-12 col-md-12 col-12">
                                                        <div className="form-group">
                                                            <input type="email" placeholder="Email*" name="email" value={formData.email} onChange={handleChange} required className="form-control" />
                                                        </div>
                                                    </div>
                                                    {/* <div className="col-lg-12 col-md-12 col-12">
                                                        <div className="form-group">
                                                            <input type="tel" required name="phone" className="form-control" placeholder="Mobile Number*" value={formData.phone} onChange={handleChange} maxLength={10} minLength={10} pattern="[0-9]*" inputMode="numeric" />
                                                        </div>
                                                    </div> */}

                                                    <div className="col-lg-12 col-md-12 col-12">
                                                        <div className={`form-group ${!formData.phone ? '' : 'valid'}`} >
                                                            <div className="conform-phone-wrap">
                                                                <div className="country-text-wrap">
                                                                    <PhoneInput
                                                                        country={country}
                                                                        onChange={(value, countryData) => {
                                                                            setCountry(countryData.countryCode);
                                                                            const dialCode = `+${countryData.dialCode}`;
                                                                            setFormData((prev) => {
                                                                                const existingNumber = prev.phone.split("-")[1] || "";
                                                                                return {
                                                                                    ...prev,
                                                                                    phone: `${dialCode}-${existingNumber}`,
                                                                                };
                                                                            });
                                                                        }}
                                                                        disableCountryCode={false}
                                                                    />
                                                                </div>
                                                                <div className="phone-wrapper">
                                                                    <input type="tel" name="phone" className="form-control phone-numbers" placeholder="Phone Number*"
                                                                        value={formData.phone.split('-')[1]?.trim() || ''}
                                                                        onChange={(e) =>
                                                                            setFormData((prev) => {
                                                                                const dialCode = prev.phone.split('-')[0]?.trim() || '+91';
                                                                                const numericValue = e.target.value.replace(/\D/g, "").slice(0, maxPhoneDigits);
                                                                                return {
                                                                                    ...prev,
                                                                                    phone: `${dialCode}-${numericValue}`,
                                                                                };
                                                                            })
                                                                        }
                                                                        onBlur={() => setPhoneTouched(true)}
                                                                        aria-invalid={Boolean(phoneError)}
                                                                        aria-describedby={phoneError ? "contact-phone-error" : undefined}
                                                                        minLength={minPhoneDigits} maxLength={maxPhoneDigits}
                                                                        pattern={country === "in" ? "[0-9]{10}" : "[0-9]{9,13}"}
                                                                        onInvalid={(e) => {
                                                                          e.preventDefault();
                                                                          setPhoneTouched(true);
                                                                        }}
                                                                        inputMode="numeric" required />
                                                                </div>
                                                            </div>
                                                            {phoneError && (
                                                              <small id="contact-phone-error" className="text-danger d-block text-start" role="alert">
                                                                {phoneError}
                                                              </small>
                                                            )}
                                                        </div>
                                                    </div>

                                                    <div className="col-lg-12">
                                                        <div className="form-group">
                                                            <input type="text" placeholder="I am looking for*" name="looking_for" value={formData.looking_for} onChange={handleChange} required className="form-control" />
                                                        </div>
                                                    </div>
                                                    <div className="btn-sec">
                                                        <button className="default-btn" disabled={loading} type="submit">
                                                            <span> {loading ? "Submitting..." : "Send Message"}</span>
                                                        </button>
                                                    </div>
                                                </div>
                                            </div>
                                        </form>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

        </>
    )
}